import type { ConversationScope } from "./conversation-query-keys";

const scopeKey = (scope: ConversationScope) =>
  [
    "playground-composer",
    scope.principalId,
    scope.organizationId,
    scope.projectId,
  ] as const;

export const composerQueryKeys = {
  tools: (scope: ConversationScope) => [...scopeKey(scope), "tools"] as const,
  autocomplete: (
    scope: ConversationScope,
    conversationId: string | undefined,
    session: string,
    search: string,
  ) =>
    [
      ...scopeKey(scope),
      "autocomplete",
      conversationId ?? null,
      session,
      search,
    ] as const,
  collections: (
    scope: ConversationScope,
    conversationId: string | undefined,
    session: string,
    toolId: string | undefined,
    search: string,
  ) =>
    [
      ...scopeKey(scope),
      "collections",
      conversationId ?? null,
      session,
      toolId ?? null,
      search,
    ] as const,
};
